module.exports = __webpack_public_path__ + "static/media/discord-dark.61d154f5.svg";